const createStringUtilities = (options = {}) => {
    const {
        includeSector = false,
        includePercentColon = false,
        includeEncodedColon = false,
        includeEncodedColonInIsCrypto = includeEncodedColon
    } = options;

    const utils = {};

    utils.capitalizeFirstChar = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    if (includeSector) {
        utils.setSectorIconName = (str) => {
            const result = (str.charAt(0).toLowerCase() + str.slice(1)).replace(' ', '');
            return result;
        };
    }

    utils.toCrypto = (str) => {
        return str
            ? str.toString().replace('^', '').replace('X:', '').replace('-', '').toString()
            : '';
    };

    utils.CryptoFormat = (str) => {
        return `X:${str.toString().replace('^', '').replace('X:', '').replace('-', '')}`.toString();
    };

    utils.toWebsocketCrypto = (str) => {
        return `X:${str.toString().replace('^', '').replace('X:', '')}`.toString();
    };

    utils.toPolygonCrypto = (str) => {
        let value = str.toString();
        if (includeEncodedColon) value = value.replace('%3A', '');
        return `X:${value.replace('^', '').replace('X:', '').replace('-', '')}`.toString();
    };

    utils.toCryptoSnapShot = (str) => {
        let value = str.toString();
        if (includeEncodedColon) value = value.replace('%3A', '');
        return `X:${value.replace('^', '').replace('X:', '').replace('-', '')}`.toString();
    };

    utils.toCryptoChartSymbol = (str) => {
        let value = str.toString();
        if (includePercentColon) value = value.replace('%', ':');
        return `^${value.replace('^', '').replace('X:', '').replace('-', '')}`.toString();
    };

    utils.isCrypto = (str) => {
        try {
            return (
                str &&
                (str.includes('^') ||
                    str.includes('X:') ||
                    str.includes('-') ||
                    (includeEncodedColonInIsCrypto ? str.includes('%3A') : false))
            );
        } catch (ex) {
            return false;
        }
    };

    return utils;
};

const stringUtilitiesFull = createStringUtilities({
    includeSector: true,
    includePercentColon: true,
    includeEncodedColon: true,
    includeEncodedColonInIsCrypto: true
});

const stringUtilitiesLite = createStringUtilities({
    includeSector: false,
    includePercentColon: false,
    includeEncodedColon: true,
    includeEncodedColonInIsCrypto: false
});

export { createStringUtilities, stringUtilitiesFull, stringUtilitiesLite };
export default stringUtilitiesFull;
